"use client";

import { useEffect, useRef } from "react";
import { useSpotifyPlayer } from "./spotify-player-context";

/** Keep the last jukebox available until its page unmounts. */
export function useJukeboxReopen(isOpen: boolean, onReopen: () => void) {
  const { registerJukeboxReopen } = useSpotifyPlayer();
  const onReopenRef = useRef(onReopen);
  const unregisterRef = useRef<(() => void) | null>(null);

  useEffect(() => {
    onReopenRef.current = onReopen;
  }, [onReopen]);

  useEffect(() => {
    if (!isOpen) return;
    unregisterRef.current?.();
    unregisterRef.current = registerJukeboxReopen(() => onReopenRef.current());
  }, [isOpen, registerJukeboxReopen]);

  useEffect(() => () => unregisterRef.current?.(), []);
}
